import { ApiResponse } from '@shared/models';
import { Department, DepartmentDto } from '@app/store/shared/models';

export class Departments {
    items: Department[];
    total: number;

    constructor(response: ApiResponse<DepartmentDto[]>) {
        this.items = response.data.map((dto) => new Department(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
